export default "__VITE_ASSET__FvXVWwGb__"